<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back"
              style=" margin-top"
              @click="previousGoods"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2>Hire Invoice</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s">

        <md-layout md-gutter class="mrgtop-2per">
          <md-layout md-flex="70"></md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="35">
            <md-layout md-flex="100">
              <label>Contract Series.</label>
              <b-form-input v-model="invoiceList.contractSeries" disabled></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="30"></md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="35">
            <md-layout md-flex="100">
              <label>Contract Type</label>
              <b-form-input v-model="invoiceList.contractType" disabled></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="10"></md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="35">
            <md-layout md-flex="100">
              <label>Shipper/Customer Name</label>
              <b-form-input v-model="invoiceList.shippingCustomerName" disabled></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="10"></md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="35">
            <md-layout md-flex="100">
              <label>Shipper/Customer Contact</label>
              <b-form-input v-model="invoiceList.shipperCustomerContact" disabled></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="15"></md-layout>
          <md-layout md-flex="40"></md-layout>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>Shipper/Customer address</label>
              <b-form-textarea v-model="invoiceList.customerAddress" disabled></b-form-textarea>
            </md-layout>
          </md-layout>
        </md-layout>

        <md-layout md-gutter v-if="vehicleDetailNumber.length>0" class="mrgtop-2per">
          <md-layout md-flex="5"></md-layout>
          <h3 id="vehicle">Vehicle Number:</h3>
        </md-layout>
        <span class="error">{{vehicleNumberError}}</span>
        <md-layout md-gutter v-if="vehicleDetailNumber.length>0">
          <md-layout md-flex="5"></md-layout>
          <md-layout
            md-flex="15"
            v-if="vehicleDetailNumber.length>0"
            v-for="(item,index) in vehicleDetailNumber"
            :key="index"
          >
            <md-checkbox
              @change="Oncheck(item.vehicleTruckId)"
              :md-value="item.vehicleTruckId"
              :name="'vehicleID'+(index+1)"
              :id="'vehicleID'+(index+1)"
              v-model="vehicleNumber[index]"
              class="md-primary"
            >{{item.regdNo}}</md-checkbox>
          </md-layout>
          <md-layout md-flex="15" v-if="vehicleDetailNumber.length>0">
            <md-checkbox @change="Oncheck('all')" class="md-primary" v-model="selectAll[0]">All</md-checkbox>
          </md-layout>
        </md-layout>

        <hr>

        <md-layout md-gutter class="mrgtop-2per">
          <md-layout md-flex="40">
            <h3
              v-if="vehicleDetailNumber.length==0"
              class="error"
            >Note: You have to complete your hire vehicle booking.</h3>
          </md-layout>
          <md-layout md-flex="60" v-if="vehicleDetailNumber.length>0">
            <md-button
              class="md-raised md-primary md-button-color"
              @click="submitInvoice"
              id="addButtonLoader"
              :disabled="permissionStatus"
            >Submit</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>

            <h3 v-if="vehicleDetailNumber.length==0">Note</h3>
          </md-layout>
        </md-layout>

        <div class="box" v-if="viewInvoice.length>0">
          <div class="box-header">
            <h3 class="box-title">All Invoices</h3>
          </div>

          <div class="box-body">
            <table id="hireModelnew1" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr.no</th>
                  <th>Truck No</th>
                  <th>Total Cost</th>
                  <th>No of days</th>

                  <th>From Date</th>
                  <th>To Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in viewInvoice" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.vehicleName}}</td>
                  <td>{{item.finalCost}}</td>
                  <td>{{item.days}}</td>

                  <td>{{item.invoiceStartDate | moment}}</td>
                  <td>{{item.loginTime | moment}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>


<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/hireInvoice/");

      if (
        this.$sessionsStorage.get("clientId") != undefined &&
        this.$sessionsStorage.get("clientId") != "" &&
        this.$sessionsStorage.get("setContractId") != undefined &&
        this.$sessionsStorage.get("setContractId") != ""
      ) {
        this.getData();
      }
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      permissionStatus: false,
      invoiceList: {
        contractSeries: "",

        shippingCustomerName: "",
        shipperCustomerContact: "",
        customerAddress: "",
        contractType: "",
        totalInvoiceCost: ""
      },
      alert: {
        content: "a",
        ok: "ok"
      },
      invoiceForm: {
        invoiceId: "",
        date: "",
        status: "",
        amountPaid: ""
      },
      invoiceData: {},
      viewPartialPayment: [],
      vehicleNumberValue: [],
      vehicleNumber: [],
      selectAll: [],
      showFollowUpActivity: ["fd"],

      dateError: "",
      vehicleNumberError: "",
      totalInvoiceCostError: "",
      amountPaidError: "",
      pendingAmountError: "",
      statusError: "",
      validateInvoice: true,

      value1: "",
      pendingAmount: "",
      vehicleDetailNumber: [],
      viewInvoice: ["df"]
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker
  },
  computed: {},
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    }
  },
  methods: {
    onClose(type) {
      this.getData();
    },
    JqueryFun() {
      return $(function() {
        return $("#hireModelnew1").DataTable();
        return $("#hireModelnew").DataTable();
      });
    },
    previousGoods() {
      this.$router.push({
        path: "/viewHireInvoice"
      });
    },

    Oncheck(value) {
      if (value == "all") {
        if (this.vehicleDetailNumber.length == this.vehicleNumberValue.length) {
          this.vehicleNumber = Array(this.vehicleDetailNumber.length).fill(
            false
          );
          this.vehicleNumberValue = [];
        } else {
          this.vehicleNumber = Array(this.vehicleDetailNumber.length).fill(
            true
          );

          this.vehicleNumberValue = this.vehicleDetailNumber.map(x => {
            return x.vehicleTruckId;
          });
        }
      } else if (this.vehicleNumberValue.indexOf(value) < 0) {
        this.vehicleNumberValue.push(value);
      } else if (this.vehicleNumberValue.indexOf(value) > -1) {
        this.vehicleNumberValue.splice(
          this.vehicleNumberValue.indexOf(value),
          1
        );
      }

      if (this.vehicleDetailNumber.length != this.vehicleNumberValue.length) {
        this.selectAll = Array(1).fill(false);
      } else {
        this.selectAll = Array(1).fill(true);
      }

      if (
        this.vehicleNumberValue.length == 0 &&
        this.vehicleDetailNumber.length != 0
      ) {
        $("#vehicle").focus();
        this.vehicleNumberError = "Select atleast one Vehicle ";
        return false;
      } else {
        this.vehicleNumberError = "";
      }
    },
    submitInvoice() {
      if (
        this.vehicleNumber.filter(x => x == true).length <= 0 &&
        this.vehicleDetailNumber.length != 0
      ) {
        $("#vehicle").focus();
        this.vehicleNumberError = "Select atleast one Vehicle ";
        return false;
      } else {
        this.vehicleNumberError = "";
      }

      this.invoiceData["vehicleNumber"] = this.vehicleNumberValue;

      $("#addButtonLoader").css("display", "none");
      $("#loader").css("display", "block");
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TPTContract/showPdfHireInvoice.php`,
        data: JSON.stringify(this.invoiceData),

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");

            window.open(data.pdfInvoice);
          }
        })
        .catch(err => {
          throw err;
        });
    },

    getData() {
      this.viewInvoice = [];
      let payload = {
        contractId: this.$sessionsStorage.get("setContractId"),

        clientId: this.$sessionsStorage.get("clientId"),
        month: this.$sessionsStorage.get("setMonth"),
        year: this.$sessionsStorage.get("setYear"),
        days: this.$sessionsStorage.get("setdays")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TPTContract/viewHireInvoice.php`,
        data: JSON.stringify(payload),

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.followActivity.length > 0) {
              this.showFollowUpActivity = [];
            } else {
              this.showFollowUpActivity = [];
            }
            if (data.contractDetails.length > 0) {
              Object.keys(data.contractDetails[0]).map(x => {
                this.invoiceList[x] = data.contractDetails[0][x] || "";
              });
            }

            if (data.viewInvoice.length > 0) {
              this.viewInvoice = data.viewInvoice;
            } else {
              this.viewInvoice = [];
            }
            this.invoiceData = data.invoiceDetail[0];

            if (data.vehicleDetail.length > 0) {
              this.vehicleDetailNumber = data.vehicleDetail;
            } else {
              this.vehicleDetailNumber = [];
            }
          }
          this.JqueryFun();
        })
        .catch(err => {
          throw err;
        });
      this.JqueryFun();
    }
  }
};
</script>
<style scoped>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 4%;
}
.mrgtop-5px {
  margin-top: 4%;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// hireInvoice.vue?65f16b29